import * as fromUser from './user.reducer';
import * as fromUserLocalStorage from './user-local-storage.reducer';
import * as fromWebsite from './website.reducer';
import * as fromTenWebProduct from './ten-web-product.reducer';
import * as fromWebsitePlugin from './website-product.reducer';
import * as fromPerformance from './performance.reducer';
import * as fromSecurity from './security.reducer';
import * as fromBackup from './backup.reducer';
import * as fromBuilderTemplates from './builder-templates.reducer';
import * as fromBackupLimits from './backup-limits.reducer';
import * as fromJob from './job.reducer';
import * as fromActivityNotifications from './activity-notifications.reducer';
import * as fromActivities from './activities.reducer';
import * as fromOngoingActivities from './ongoing-activities.reducer';
import * as fromOngoingActivity from './ongoing-activity.reducer';
import * as fromUserSummaries from './user-summaries.reducer';
import * as fromTourSection from './tour-section.reducer';
import * as fromChatOverlaySection from './chat-overlay-section.reducer';
import {ActionReducerMap} from "@ngrx/store";
import * as fromHostingDomains from './hosting-domains.reducer';
import * as fromHostingZones from './hosting-zones.reducer';
import * as fromHostingRedirects from './hosting-redirects.reducer';
import * as fromHostingLogs from './hosting-logs.reducer';
import * as fromHostingInfo from './hosting-info.reducer';
import * as fromHostingCertificates from './hosting-certificates.reducer';
import * as fromHostingSettings from './hosting-settings.reducer';
import * as fromHostingCacheExclude from './hosting-cache-exclude.reducer';
import * as fromHostingResources from './hosting-resources.reducer';
import * as fromHostingVisits from './hosting-visits.reducer';
import * as fromHostingPhpConfigs from './hosting-php-configs.reducer';
import * as fromWebsiteTags from './website-tags.reducer';
import * as fromKnowledgeBase from './knowledge-base.reducer';
import * as fromWorkspace from './workspace.reducer';
import * as fromWorkspaceSwitcher from './workspace-switcher.reducer';
import * as fromWebsiteSidebar from './website-sidebar.reducer';
import * as fromAiSidebar from './ai-sidebar.reducer';
import * as fromBooster from './booster.reducer';
import * as fromBoosterData from './booster-data.reducer';
import * as fromBoosterAdvancedSettings from './booster-advanced-settings.reducer';
import * as fromAiBuilder from './ai-builder.reducer';
import * as fromCloudflareData from './cloudflare-data.reducer';
import * as fromImageOptimizer from './image-optimizer.reducer';
import * as fromUserPaymentMethods from './user-payment-methods.reducer';
import * as fromEcommerce from './ecommerce.reducer';
import * as fromEcommerceOrders from './ecommerce-orders.reducer';
import * as fromEcommerceCustomers from './ecommerce-customers.reducer';
import * as fromEcommerceProduct from './ecommerce-product.reducer';
import * as fromPayments from './payments.reducer';
import * as fromEcommerceSetupList from './ecommerce-setup-list.reducer';
import * as fromEcommerceSettings from './ecommerce-settings.reducer';
import * as fromEcommerceNavigation from './ecommerce-navigation.reducer';
import * as fromEcommerceMerchant from './ecommerce-merchant.reducer';
import * as fromEcommerceMerchantHash from './ecommerce-merchant-hash.reducer';
import * as fromEcommercePayoutsAmount from './ecommerce-payouts-amount.reducer';
import * as fromEcommerceWorkspaceMerchants from './ecommerce-workspace-merchants.reducer';
import * as fromEcommercePaymentMethods from './ecommerce-payment-methods.reducer';
import * as fromEcommercePublicKey from './ecommerce-public-key.reducer';
import * as fromEcommercePerformance from './ecommerce-performance.reducer';
import * as fromEcommerceAnalytics from './ecommerce-analytics.reducer';
import * as fromEcommerceRefunds from './ecommerce-refunds.reducer';
import * as fromEcommercePerformanceNow from './ecommerce-performance-now.reducer';
import * as fromEcommercePerformanceReportOrders from './ecommerce-performance-report-order.reducer';
import * as fromEcommercePerformanceReportOrdersLastYear from './ecommerce-performance-report-order-last-year.reducer';
import * as fromEcommercePerformanceReportNetSales from './ecommerce-performance-net-sales.reducer';
import * as fromEcommercePerformanceReportNetSalesLastYear from './ecommerce-performance-net-sales-last-year.reducer';
import * as fromEcommerceTaxSettings from './ecommerce-tax-settings.reducer';
import * as fromEcommerceTaxRates from './ecommerce-tax-rates.reducer';
import * as fromEcommerceTaxClasses from './ecommerce-tax-classes.reducer';
import * as fromEcommerceGeneralSettings from './ecommerce-general-settings.reducer';
import * as fromEcommerceEmailsList from './ecommerce-emails-list.reducer';
import * as fromEcommerceEmailsSettings from './ecommerce-emails-settings.reducer';
import * as fromDomainsPortfolio from './domains-portfolio.reducer';
import * as fromDomainExpandedData from './domain-expanded-data.reducer';
import * as fromBackupList from './backup-list.reducer';
import * as fromBackupSettings from './backup-settings.reducer';
import * as fromWPVersion from './website-wp-version.reducer';
import * as fromCloudflareDefaultRecord from './cloudflare-default-dns-record.reducer';
import * as fromCacheRules from './cache-rules.reducer';
import * as fromTroubleShootData from './troubleshoot.reducer';
import * as fromBandwidth from './bandwidth.reducer';
import * as fromZone from './websites-zone.reducer';
import {IActivity} from "../../activities/activity";
import * as fromTenWebApi from './10web-api.reducer';
import * as fromUsedAiCredits from './used-ai-credits.reducer';
import * as fromCompanyInfo from './company-info.reducer';
import * as fromVibeFiles from './vibe-files.reducer';
import * as fromVibeLimitations from './vibe-limitations.reducer';

export interface DbStoreState {
  user: fromUser.IUserState;
  userLocalStorage: fromUserLocalStorage.IUserLocalStorageState;
  userPayments: fromPayments.IUserPaymentsState;
  userPaymentMethods: fromUserPaymentMethods.IUserPaymentMethodsState;
  website: fromWebsite.IWebsiteState;
  tenWebProduct: fromTenWebProduct.ITenWebProductState;
  performance: fromPerformance.IPerformanceState;
  security: fromSecurity.ISecurityState;
  backup: fromBackup.IBackupState;
  builderTemplates: fromBuilderTemplates.IBuilderTemplateState;
  backupLimits: fromBackupLimits.IBackupLimitsState;
  job: fromJob.IJobState;
  websiteProduct: fromWebsitePlugin.IWebsiteProductState;
  activityNotifications: fromActivityNotifications.IActivityNotificationsState;
  activities: fromActivities.IActivitiesState;
  ongoingActivities: fromOngoingActivities.IOngoingActivitiesState;
  ongoingActivity: IActivity;
  userSummaries: fromUserSummaries.IUserSummariesState;
  tourSection: fromTourSection.ITourSectionState;
  chatOverlaySection: fromChatOverlaySection.IChatOverlaySectionState;
  hostingDomains: fromHostingDomains.IHostingDomainsState;
  hostingZones: fromHostingZones.IHostingZoneState;
  hostingRedirects: fromHostingRedirects.IHostingRedirectsState;
  hostingLogs: fromHostingLogs.IHostingLogsState;
  hostingInfo: fromHostingInfo.IHostingInfoState;
  hostingCertificates: fromHostingCertificates.IHostingCertificatesState;
  hostingSettings: fromHostingSettings.IHostingSettingsState;
  hostingCacheExclude: fromHostingCacheExclude.IHostingCacheExcludeState;
  hostingResources: fromHostingResources.IHostingResourcesState;
  hostingVisits: fromHostingVisits.IHostingVisitsState;
  websiteWPVersion: fromWPVersion.IWebsiteWPVersionState;
  phpConfigs: fromHostingPhpConfigs.IPhpConfigsState;
  websiteTags: fromWebsiteTags.IWebsiteTagsState;
  knowledgeBase: fromKnowledgeBase.IKnowledgeBaseState;
  workspace: fromWorkspace.IWorkspaceState;
  workspaceSwitcher: fromWorkspaceSwitcher.IWorkspaceSwitcherState;
  websiteSidebar: fromWebsiteSidebar.IWebsiteSidebar;
  aiSidebar: fromAiSidebar.IAiSidebar;
  booster: fromBooster.IBoosterState;
  boosterData: fromBoosterData.IBoosterData;
  boosterAdvancedSettings: fromBoosterAdvancedSettings.IBoosterAdvancedSettingsState;
  troubleShootData: fromTroubleShootData.ITroubleShootData;
  aiBuilder: fromAiBuilder.IAiBuilderState;
  cloudflareData: fromCloudflareData.ICloudflareDataState;
  /*
    cloudflareSetData: fromCloudflareSetData.ICloudflareSetDataState;
  */
  cloudflareDefaultRecord: fromCloudflareDefaultRecord.ICloudflareDefaultRecordState;
  cacheRules: fromCacheRules.ICacheRulesState;
  bandwidth: fromBandwidth.IBandwidthState;
  imageOptimizer: fromImageOptimizer.ImageOptimizerState;
  ecommerce: fromEcommerce.IEcommerceState;
  ecommerceOrders: fromEcommerceOrders.IEcommerceOrdersState;
  ecommerceCustomers: fromEcommerceCustomers.IEcommerceCustomersState;
  ecommerceProduct: fromEcommerceProduct.IEcommerceProductState;
  ecommerceSetupList: fromEcommerceSetupList.IEcommerceSetupListState;
  ecommerceSettings: fromEcommerceSettings.IEcommerceSettingsState;
  ecommerceMerchant: fromEcommerceMerchant.IEcommerceMerchantState;
  ecommerceMerchantHash: fromEcommerceMerchantHash.IEcommerceMerchantHashState;
  ecommerceMerchantPayoutsAmount: fromEcommercePayoutsAmount.IEcommerceMerchantPayoutsAmountState;
  ecommerceWorkspaceMerchants: fromEcommerceWorkspaceMerchants.IEcommerceWorkspaceMerchantsState;
  ecommercePaymentMethods: fromEcommercePaymentMethods.IEcommercePaymentMethodsState;
  ecommercePublicKey: fromEcommercePublicKey.IEcommercePublicKeyState;
  ecommerceRefunds: fromEcommerceRefunds.IEcommerceRefundsState;
  ecommerceTaxSettings: fromEcommerceTaxSettings.IEcommerceTaxSettingsState;
  ecommerceTaxRates: fromEcommerceTaxRates.IEcommerceTaxRatesState;
  ecommerceTaxClasses: fromEcommerceTaxClasses.IEcommerceTaxClassesState;
  ecommerceGeneralSettings: fromEcommerceGeneralSettings.IEcommerceGeneralSettingsState;
  ecommerceEmailsList: fromEcommerceEmailsList.IEcommerceEmailsListState;
  ecommerceEmailsSettings: fromEcommerceEmailsSettings.IEcommerceEmailsSettingsState;
  ecommerceAnalytics: fromEcommerceAnalytics.IEcommerceAnalyticsState;
  ecommercePerformance: fromEcommercePerformance.IEcommercePerformanceState;
  ecommercePerformanceNow: fromEcommercePerformanceNow.IEcommercePerformanceNowState;
  ecommercePerformanceReportOrders: fromEcommercePerformanceReportOrders.IEcommercePerformanceReportOrdersState;
  ecommercePerformanceReportOrdersLastYear: fromEcommercePerformanceReportOrdersLastYear.IEcommercePerformanceReportOrdersLastYearState;
  ecommercePerformanceReportNetSales: fromEcommercePerformanceReportNetSales.IEcommercePerformanceReportNetSalesState;
  ecommercePerformanceReportNetSalesLastYear: fromEcommercePerformanceReportNetSalesLastYear.IEcommercePerformanceReportNetSalesLastYearState;
  ecommerceNavigation: fromEcommerceNavigation.IEcommerceNavigationState;
  domainsPortfolio: fromDomainsPortfolio.IDomainsPortfolioState;
  domainExpandedData: fromDomainExpandedData.IDomainExpandedDataState;
  backupList: fromBackupList.IBackupListState;
  backupSettings: fromBackupSettings.IBackupSettingsState;
  websiteZone: fromZone.IZoneState;
  tenWebApi: fromTenWebApi.ITenWebApiState;
  usedAiCredits: fromUsedAiCredits.UsedAiCreditsState;
  companyInfo: fromCompanyInfo.ICompanyInfoState;
  vibeFiles: fromVibeFiles.IVibeFilesState;
  vibeLimitations: fromVibeLimitations.IVibeLimitationsState;
}

export const reducers: ActionReducerMap<DbStoreState> = {
  user: fromUser.reducer,
  userLocalStorage: fromUserLocalStorage.reducer,
  userPayments: fromPayments.reducer,
  userPaymentMethods: fromUserPaymentMethods.reducer,
  website: fromWebsite.reducer,
  tenWebProduct: fromTenWebProduct.reducer,
  performance: fromPerformance.reducer,
  security: fromSecurity.reducer,
  backup: fromBackup.reducer,
  builderTemplates: fromBuilderTemplates.reducer,
  backupLimits: fromBackupLimits.reducer,
  job: fromJob.reducer,
  websiteProduct: fromWebsitePlugin.reducer,
  activityNotifications: fromActivityNotifications.reducer,
  activities: fromActivities.reducer,
  ongoingActivities: fromOngoingActivities.reducer,
  ongoingActivity: fromOngoingActivity.reducer,
  userSummaries: fromUserSummaries.reducer,
  tourSection: fromTourSection.reducer,
  chatOverlaySection: fromChatOverlaySection.reducer,
  hostingDomains: fromHostingDomains.reducer,
  hostingZones: fromHostingZones.reducer,
  hostingRedirects: fromHostingRedirects.reducer,
  hostingLogs: fromHostingLogs.reducer,
  hostingInfo: fromHostingInfo.reducer,
  hostingCertificates: fromHostingCertificates.reducer,
  hostingCacheExclude: fromHostingCacheExclude.reducer,
  hostingSettings: fromHostingSettings.reducer,
  hostingResources: fromHostingResources.reducer,
  hostingVisits: fromHostingVisits.reducer,
  websiteWPVersion: fromWPVersion.reducer,
  phpConfigs: fromHostingPhpConfigs.reducer,
  websiteTags: fromWebsiteTags.reducer,
  knowledgeBase: fromKnowledgeBase.reducer,
  workspace: fromWorkspace.reducer,
  workspaceSwitcher: fromWorkspaceSwitcher.reducer,
  websiteSidebar: fromWebsiteSidebar.reducer,
  aiSidebar: fromAiSidebar.reducer,
  booster: fromBooster.reducer,
  boosterData: fromBoosterData.reducer,
  boosterAdvancedSettings: fromBoosterAdvancedSettings.reducer,
  aiBuilder: fromAiBuilder.reducer,
  cloudflareData: fromCloudflareData.reducer,
  /*
    cloudflareSetData: fromCloudflareSetData.reducer,
  */
  cloudflareDefaultRecord: fromCloudflareDefaultRecord.reducer,
  cacheRules: fromCacheRules.reducer,
  bandwidth: fromBandwidth.reducer,
  troubleShootData: fromTroubleShootData.reducer,
  imageOptimizer: fromImageOptimizer.reducer,
  ecommerce: fromEcommerce.reducer,
  ecommerceOrders: fromEcommerceOrders.reducer,
  ecommerceCustomers: fromEcommerceCustomers.reducer,
  ecommerceProduct: fromEcommerceProduct.reducer,
  ecommerceSetupList: fromEcommerceSetupList.reducer,
  ecommerceSettings: fromEcommerceSettings.reducer,
  ecommerceMerchant: fromEcommerceMerchant.reducer,
  ecommerceMerchantHash: fromEcommerceMerchantHash.reducer,
  ecommerceMerchantPayoutsAmount: fromEcommercePayoutsAmount.reducer,
  ecommerceWorkspaceMerchants: fromEcommerceWorkspaceMerchants.reducer,
  ecommercePaymentMethods: fromEcommercePaymentMethods.reducer,
  ecommercePublicKey: fromEcommercePublicKey.reducer,
  ecommerceRefunds: fromEcommerceRefunds.reducer,
  ecommerceTaxSettings: fromEcommerceTaxSettings.reducer,
  ecommerceTaxRates: fromEcommerceTaxRates.reducer,
  ecommerceGeneralSettings: fromEcommerceGeneralSettings.reducer,
  ecommerceEmailsList: fromEcommerceEmailsList.reducer,
  ecommerceEmailsSettings: fromEcommerceEmailsSettings.reducer,
  ecommerceAnalytics: fromEcommerceAnalytics.reducer,
  ecommerceTaxClasses: fromEcommerceTaxClasses.reducer,
  ecommercePerformance: fromEcommercePerformance.reducer,
  ecommercePerformanceNow: fromEcommercePerformanceNow.reducer,
  ecommercePerformanceReportOrders: fromEcommercePerformanceReportOrders.reducer,
  ecommercePerformanceReportOrdersLastYear: fromEcommercePerformanceReportOrdersLastYear.reducer,
  ecommercePerformanceReportNetSales: fromEcommercePerformanceReportNetSales.reducer,
  ecommercePerformanceReportNetSalesLastYear: fromEcommercePerformanceReportNetSalesLastYear.reducer,
  ecommerceNavigation: fromEcommerceNavigation.reducer,
  domainsPortfolio: fromDomainsPortfolio.reducer,
  domainExpandedData: fromDomainExpandedData.reducer,
  backupList: fromBackupList.reducer,
  backupSettings: fromBackupSettings.reducer,
  websiteZone: fromZone.reducer,
  tenWebApi: fromTenWebApi.reducer,
  usedAiCredits: fromUsedAiCredits.usedAiCreditsReducer,
  companyInfo: fromCompanyInfo.companyInfoReducer,
  vibeFiles: fromVibeFiles.vibeFilesReducer,
  vibeLimitations: fromVibeLimitations.vibeLimitationsReducer,
};
